import React from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const RoleSection = ({label, displayText, type, onClick}) => (
    <div className="flex flex-col gap-1 w-full">
        <span className="text-xs text-main-light">{label}</span>
        <button
            type="button"
            data-testid={`role-section-${type}`}
            className="flex items-center justify-between w-full px-3 py-2 rounded-input border border-panels-normal bg-windowsandmenus-normal text-sm font-medium text-main-normal cursor-pointer hover:border-classic-button-normal"
            onClick={(e) => onClick(e, type)}
        >
            <span>{displayText}</span>
            <KeyboardArrowDownIcon style={{fontSize: 18}} className="text-main-light" />
        </button>
    </div>
);

export default RoleSection;
